import {
  Award,
  BadgeDollarSign,
  BookOpen,
  CalendarDays,
  FlaskConical,
  GraduationCap,
  type LucideIcon,
} from "lucide-react";

export type NeedId =
  | "notes"
  | "tuition"
  | "practicals"
  | "scholarships"
  | "bursaries"
  | "dates";
export type LevelId = "ip" | "o-level" | "h2" | "igcse" | "ib";
export type SubjectId =
  | "maths"
  | "physics"
  | "chemistry"
  | "biology"
  | "general";
export type GuidedChipGroup = "need" | "level" | "subject";

export type NeedOption = {
  id: NeedId;
  label: string;
  query: string;
  Icon: LucideIcon;
};

export type GuidedOption<T extends string> = {
  id: T;
  label: string;
  query: string;
};

export const NEED_OPTIONS: NeedOption[] = [
  { id: "notes", label: "Notes", query: "notes", Icon: BookOpen },
  { id: "tuition", label: "Tuition", query: "tuition", Icon: GraduationCap },
  {
    id: "practicals",
    label: "Practicals",
    query: "practicals",
    Icon: FlaskConical,
  },
  {
    id: "scholarships",
    label: "Scholarships",
    query: "scholarships",
    Icon: Award,
  },
  {
    id: "bursaries",
    label: "Bursaries",
    query: "bursaries",
    Icon: BadgeDollarSign,
  },
  {
    id: "dates",
    label: "Dates",
    query: "school calendar dates",
    Icon: CalendarDays,
  },
];

export const LEVEL_OPTIONS: GuidedOption<LevelId>[] = [
  { id: "ip", label: "IP", query: "IP" },
  { id: "o-level", label: "O-Level", query: "O-Level" },
  { id: "h2", label: "A-Level / H2", query: "H2" },
  { id: "igcse", label: "IGCSE", query: "IGCSE" },
  { id: "ib", label: "IB", query: "IB" },
];

export const SUBJECT_OPTIONS: GuidedOption<SubjectId>[] = [
  { id: "maths", label: "Maths", query: "Maths" },
  { id: "physics", label: "Physics", query: "Physics" },
  { id: "chemistry", label: "Chemistry", query: "Chemistry" },
  { id: "biology", label: "Biology", query: "Biology" },
  { id: "general", label: "General", query: "" },
];

export function composeGuidedSearchQuery({
  freeText,
  need,
  level,
  subject,
}: {
  freeText: string;
  need: NeedId | null;
  level: LevelId | null;
  subject: SubjectId | null;
}): string {
  const selectedNeed = NEED_OPTIONS.find((option) => option.id === need);
  const selectedLevel = LEVEL_OPTIONS.find((option) => option.id === level);
  const selectedSubject = SUBJECT_OPTIONS.find(
    (option) => option.id === subject
  );
  const composed = [
    selectedLevel?.query,
    selectedSubject?.query,
    selectedNeed?.query,
  ]
    .filter(Boolean)
    .join(" ")
    .trim();

  return composed || freeText.trim();
}
